import api from './../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const networksGroupStartRequest = () => {
  return {
    type: 'NETWORKS_GROUP_START_REQUEST'
  };
};

export const networksGroupEndRequest = () => {
  return {
    type: 'NETWORKS_GROUP_END_REQUEST'
  };
};

export const getAllNetworksGroupSuccess = ({ data }) => {
  return {
    type: 'NETWORKS_GROUP_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllNetworksGroupError = error => {
  return {
    type: 'NETWORKS_GROUP_GET_ALL_ERROR',
    payload: error
  };
};

export const addNetworksGroupSuccess = ({ data }) => {
  return {
    type: 'NETWORKS_GROUP_ADD_SUCCESS',
    payload: data
  };
};

export const addNetworksGroupError = error => {
  return {
    type: 'NETWORKS_GROUP_ADD_ERROR',
    payload: error
  };
};

export const editNetworksGroupSuccess = ({ data }) => {
  return {
    type: 'NETWORKS_GROUP_EDIT_SUCCESS',
    payload: data
  };
};

export const editNetworksGroupError = error => {
  return {
    type: 'NETWORKS_GROUP_EDIT_ERROR',
    payload: error
  };
};

export const removeNetworksGroupSuccess = id => {
  return {
    type: 'NETWORKS_GROUP_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeNetworksGroupError = error => {
  return {
    type: 'NETWORKS_GROUP_REMOVE_ERROR',
    payload: error
  };
};

export const networksGroupModifyStore = ({ data }) => {
  return {
    type: 'NETWORKS_GROUP_MODIFY_STORE',
    payload: data
  };
};

export const addNetworksGroup = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(networksGroupStartRequest());
      const response = await api().post('/api/networks_group', data);
      dispatch(addNetworksGroupSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'networksGroup',
        data: [response.data]
      });
      formReset();
    } catch (err) {
      dispatch(addNetworksGroupError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(networksGroupEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllNetworksGroup = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(networksGroupStartRequest());
      const response = await api().get('/api/networks_group', { params });
      dispatch(getAllNetworksGroupSuccess(response));
    } catch (err) {
      dispatch(getAllNetworksGroupError(err));
    } finally {
      dispatch(networksGroupEndRequest());
    }
  };
};

export const editNetworksGroup = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(networksGroupEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(networksGroupStartRequest());
      const id = data._id;
      const response = await api().put('/api/networks_group/' + id, data);
      dispatch(editNetworksGroupSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'networksGroup',
        data: [response.data]
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/networks_group'));
      }
    } catch (err) {
      dispatch(editNetworksGroupError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeNetworksGroup = id => {
  return async dispatch => {
    try {
      dispatch(networksGroupStartRequest());
      await api().delete('/api/networks_group/' + id);
      dispatch(removeNetworksGroupSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'networksGroup',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Grupo de tronco removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeNetworksGroupError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover grupo de tronco.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(networksGroupEndRequest());
    }
  };
};

export const restoreNetworksGroup = data => {
  return async dispatch => {
    try {
      dispatch(networksGroupStartRequest());
      const id = data._id;
      const response = await api().put('/api/networks_group/' + id, data);
      dispatch(editNetworksGroupSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'networksGroup',
        data: [response.data]
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Grupo de tronco restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editNetworksGroupError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar grupo de tronco.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(networksGroupEndRequest());
    }
  };
};
